/**
 * Match channel + format against controlled mediumRules (first match wins).
 */
export const applyMediumRules = ({ channel, format, mediumRules = [], mediumDefault = 'referral' }) => {
  if (!channel || !format) {
    return mediumDefault
  }

  const rule = mediumRules.find(
    ({ channel: ruleChannel, formats }) => ruleChannel === channel && formats.includes(format)
  )

  return rule?.medium ?? mediumDefault
}

export default applyMediumRules
